import { z } from 'zod';
import '@apexdesigner/schema-tools';
import {
  hasMany,
  hasOne,
  options,
  references,
} from '@apexdesigner/schema-tools';

export const resource = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z.string().nullable().optional().describe('Name'),

    type: options([
      { value: 'Click the word', name: 'Click the word' },
      { value: 'Fill in the blank', name: 'Fill in the blank' },
      { value: 'PDF', name: 'PDF' },
      { value: 'Move pictures', name: 'Move pictures' },
      { value: 'Move letters', name: 'Move letters' },
      { value: 'Tattum board', name: 'Tattum board' },
    ])
      .nullable()
      .optional()
      .describe('Type'),

    instructions: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Instructions'),

    locked: z.boolean().nullable().optional().hidden().describe('locked'),

    uuid: z.string().nullable().optional().hidden().describe('uuid'),

    version: z.number().nullable().optional().hidden().describe('version'),

    status: z.string().nullable().optional().hidden().describe('status'),

    createdAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('createdAt'),

    publishedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('publishedAt'),

    archivedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('archivedAt'),

    createdById: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to User'),

    publishedById: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to User'),

    archivedById: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to User'),

    categoryItems: hasMany('ResourceCategoryItem'),

    pdfDocument: hasOne('PdfDocument'),

    images: hasMany('Image'),

    sessionActivityItems: hasMany('SessionActivityItem'),

    textBoxes: hasMany('TextBox'),

    sentences: hasMany('ResourceSentence'),

    createdBy: references('User'),

    publishedBy: references('User'),

    archivedBy: references('User'),
  })
  .describe('A versioned piece of tutoring content.')
  .as('Resource');

export { resource as resourceSchema };
